import PropTypes from "prop-types"
import styled, { css } from "styled-components"
import breakpoint from "styled-components-breakpoint"

export const ContainerPadding = "16px"

export const Container = styled.div`
  ${props =>
    props?.maxWidth?.sm ? `max-width:${props.maxWidth.sm}` : "max-width:600px"};
  width: 100%;
  margin: 0 auto;
  flex-grow: 1;
  padding: 0 ${ContainerPadding};

  ${props =>
    props.centered &&
    css`
      text-align: center;
    `}

  ${breakpoint("md")(css`
    ${props => {
      if (props.maxWidth?.md) return `max-width:${props.maxWidth.md}`
      if (props.maxWidth) return `max-width:${props.maxWidth}`

      return `max-width:1132px`
    }};
  `)}
`

Container.propTypes = {
  maxWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  centered: PropTypes.bool,
}
